<template>
  <Note
    :is-quick-note="true"
    :note-id="noteId"
    @createNote="handleCreate"
    @close="handleClose"
  />
</template>

<script setup lang="ts">
import { watch, ref } from 'vue';
import Note from '@/components/notes/Note.vue';
import constants from '@/utilities/constants';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();

const noteId = ref(constants.newNote);

const handleCreate = (newVal: string) => {
  noteId.value = newVal;
};

const handleClose = () => {
  store.dispatch('setQuickNote', false);
};

watch(
  () => route.path,
  () => {
    handleClose();
  }
);
</script>
